import React from "react";

const Vision = () => {
  return (
    <div className="flex flex-col justify-center items-center text-center bg-gradient-to-b from-[#7EB9FF] to-[#E5F1FF] rounded-b-[40px] md:rounded-b-[100px]">
      <div className="w-4/5 md:w-3/5 flex flex-col justify-center items-center gap-2 md:gap-3 lg:gap-5 mt-80 md:mt-48 lg:mt-72">
        <p className="text-xl md:text-2xl lg:text-3xl font-semibold font-Montserrat tracking-[10px] my-0">
          VISION
        </p>
        <p className="text-2xl md:text-3xl lg:text-4xl font-bold text-center font-syne my-2 leading-10">
          To redefine global problem-solving <br className="hidden lg:flex" />
          by making high-tech solutions
          <br className="hidden lg:flex" />
          universally accessible.
        </p>
      </div>

      <img src="/vision.png" className="flex w-4/5" alt="vision png" />
    </div>
  );
};

export default Vision;
